import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=1d1c3847&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d1c3847')) {
      api.createRecord('1d1c3847', component.options)
    } else {
      api.reload('1d1c3847', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=1d1c3847&", function () {
      api.rerender('1d1c3847', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CoJbqtkQ3exd/JS/comp/ErrorMessage.vue"
export default component.exports